__webpack_require__.p = "/ch/fr/appointment/";